// extracted by mini-css-extract-plugin
module.exports = {"row":"Section_row__22bWT","row_full":"Section_row_full__c9sBH"};